import React, { useState, useEffect } from 'react';
import './Home.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import LoginModal from '../components/LoginModal';
import SignupModal from '../components/SignupModal';

const Home = () => {
  const navigate = useNavigate();
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const syncTheme = () => {
      const savedMode = localStorage.getItem("darkMode");
      setDarkMode(savedMode ? JSON.parse(savedMode) : false);
    };
    syncTheme();
    window.addEventListener("themeChanged", syncTheme);
    return () => window.removeEventListener("themeChanged", syncTheme);
  }, []);

  useEffect(() => {
    const checkLoginStatus = () => {
      const userEmail = localStorage.getItem("userEmail");
      const googleEmail = localStorage.getItem("googleEmail");
      const adminEmail = localStorage.getItem("adminEmail");

      setIsUserLoggedIn(!!(userEmail || googleEmail));
      setIsAdminLoggedIn(!!adminEmail);
    };

    checkLoginStatus();

    window.addEventListener("userLoggedIn", checkLoginStatus);

    window.addEventListener("userLoggedOut", () => {
      checkLoginStatus();
      navigate("/");
    });

    return () => {
      window.removeEventListener("userLoggedIn", checkLoginStatus);
      window.removeEventListener("userLoggedOut", checkLoginStatus);
    };
  }, [navigate]);

  const handleLoginSuccess = () => {
    setShowLogin(false);
    setShowSignup(false);
  };

  return (
    <div className={darkMode ? "app dark-mode" : "app"}>
      <div className="home-container">

        <img
          src="/ai_text_detector.png"
          alt="Source Check Logo"
          style={{ width: '200px', height: '200px', marginBottom: '5px' }}
          className="logo-pop-in"
        />

        <h1
          style={{
            fontSize: '2.5em',
            fontWeight: '700',
            color: 'var(--text-main)',
            marginBottom: '10px',
          }}
        >
          Welcome to SourceCheck
        </h1>

        <p
          style={{
            fontStyle: 'italic',
            color: '#696c71ff',
            fontSize: '0.9em',
            maxWidth: '600px',
            margin: '0 auto 50px auto',
            marginBottom: '20px',
          }}
        >
          "Instantly analyze and verify the originality of any written content."
        </p>

        {isUserLoggedIn && !isAdminLoggedIn && (
          <button
            onClick={() => navigate("/DetectorApp")}
            style={{
              background: 'linear-gradient(90deg, #636CCB, #8CA9FF, #636CCB)',
              color: 'white',
              border: 'none',
              borderRadius: '30px',
              padding: '12px 28px',
              fontSize: '1.1em',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(130, 94, 121, 0.3)',
            }}
          >
            Check for AI and Plagiarism <FaArrowRight />
          </button>
        )}

        {isAdminLoggedIn && (
          <button
            onClick={() => navigate("/admin")}
            style={{
              background: 'linear-gradient(90deg, #636CCB, #8CA9FF, #636CCB)',
              color: 'white',
              border: 'none',
              borderRadius: '30px',
              padding: '12px 28px',
              fontSize: '1.1em',
              fontWeight: '600',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(130, 94, 121, 0.3)',
            }}
          >
            Go to Admin Dashboard <FaArrowRight />
          </button>
        )}

        {!isUserLoggedIn && !isAdminLoggedIn && (
          <button
            onClick={() => setShowLogin(true)}
            style={{
              marginTop: "20px",
              background: 'linear-gradient(90deg, #636CCB, #8CA9FF, #636CCB)',
              color: 'white',
              border: 'none',
              borderRadius: '30px',
              padding: '12px 28px',
              fontSize: '1.1em',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(130, 94, 121, 0.3)',
            }}
          >
            Login / Signup
          </button>
        )}

        {showLogin && (
          <LoginModal
            onClose={() => setShowLogin(false)}
            onLoginSuccess={handleLoginSuccess}
            openSignup={() => {
              setShowLogin(false);
              setShowSignup(true);
            }}
          />
        )}

        {showSignup && (
          <SignupModal
            onClose={() => setShowSignup(false)}
            openLogin={() => {
              setShowSignup(false);
              setShowLogin(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default Home;
